import { CONSTANTS } from '../_data/lookups.js';
function createWorkflowProvenance(workflowTraceHandle, toolStepRoleAddress) {
    return {
        provenanceKind: CONSTANTS.Enums.ProvenanceKind.workflow,
        workflowTraceHandle,
        toolStepRoleAddress,
    };
}
function createRuntimeProvenance() {
    return {
        provenanceKind: CONSTANTS.Enums.ProvenanceKind.runtime,
    };
}
function createResourcePointer(id, resourceTypeHandle, provenance) {
    return {
        id,
        resourceTypeHandle,
        provenance,
    };
}
function createResource(resourcePointer, projection) {
    return {
        ...resourcePointer,
        projection,
    };
}
export function createResourceFromDescriptor(descriptor, projection) {
    const provenance = 'toolStepRoleAddress' in descriptor
        ? createWorkflowProvenance(descriptor.workflowTraceHandle, descriptor.toolStepRoleAddress)
        : createRuntimeProvenance();
    return createResource(createResourcePointer(descriptor.id, descriptor.resourceTypeHandle, provenance), projection);
}
